export type FloatieRibbonId = FloatieRibbonGroupId;

// Editor floatie group types: reserved range [9000-10000]
export enum FloatieRibbonGroupId {
    BasicTextGroup = 9000,
    TableEditGroup,
    MoreOptionsGroup,
}
